module.exports = __webpack_public_path__ + "static/assets/6ea5a7c789b0f5212a4e461fd705bac5.png";